import React from 'react';
import styled, { keyframes } from 'styled-components';

interface LogoWaveProps {
  size: 'mobile' | 'small' | 'standard';
}

const LogoWave: React.FC<LogoWaveProps> = ({ size }) => {

  return (
    <Wave $size={size}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </Wave>
  );
};


const waveAnimation = keyframes`
  0%, 40%, 100% { transform: scaleY(1); }
  20% { transform: scaleY(0.7); }
`;

const Wave = styled.div<{ $size: 'mobile' | 'small' | 'standard' }>`
  display: flex;
  align-items: center;

  div {
    width: ${({ $size }) => $size === 'mobile' ? '5px' : $size === 'small' ? '4px' : '7px'};
    height: ${({ $size }) => $size === 'mobile' ? '20px' : $size === 'small' ? '16px' : '30px'};
    background-color: black;
    margin: 0 ${({ $size }) => $size === 'mobile' ? '2px' : $size === 'small' ? '1.5px' : '2px'};
    animation: ${waveAnimation} 1s ease-in-out infinite;

    &:nth-child(1) {
      animation-delay: -0.4s;
    }
    &:nth-child(2) {
      animation-delay: -0.3s;
    }
    &:nth-child(3) {
      animation-delay: -0.2s;
    }
    &:nth-child(4) {
      animation-delay: -0.1s;
    }
    &:nth-child(5) {
      animation-delay: 0s;
    }
  }
`;


export default LogoWave;